import React, { useEffect, useState } from "react";
import { useRequest } from "../../../abstracts";
import { Field } from "formik";
import { isEmpty } from "lodash";
import {
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  usDateFormat,
  yesNoOptions,
  clearFieldValues,
} from "../../../utils";
import {
  FieldInput,
  FieldButtonGroup,
  FieldDropSide,
  DatePicker,
} from "../../../components";
import SourceDropdown from "../../../components/SourceNameDropDown/SourceNameDropDown";
import { GetMasterSourceNames } from "../../../services";

const EmployeeForm = (props) => {
  const {
    fields,
    setValues,
    setErrors,
    values,
    isEdit,
    isSave,
    setFieldValue,
    hasAdditionalRules,
    handleChange,
    deleteAdditionalAlloc,
    companyId,
  } = props;

  const onSourceCategoryChange = (value) => {
    const updatedValues = clearFieldValues({
      values,
      fieldsToExclude: [fields.sourceType, fields.recordKeepingNumber],
      fieldsToClear: [fields.sourceName],
    });
    setValues({
      ...updatedValues,
      [fields.sourceCategory]: value,
      [fields.isNewContributionAllowed]: false,
      [fields.isDisplayToParticipantWebsite]: false,
      [fields.isContributionMandatory]: false,
      [fields.contributionType]: 1,
    });
    setErrors({});
  };

  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  const payload = {
    companyId: companyId || 0,
    sourceType: values[fields.sourceType] || 0,
    sourceCategory: values[fields.sourceCategory] || 0,
    subCategory: values[fields.sourceSubCategory] || 0,
    subSubCategory: values[fields.sourceSubSubCategory] || 0,
  };
  const { response: dropdownList, loading } = useRequest({
    method: GetMasterSourceNames,
    payload,
  });

  const [sourceNameDropDown, setSourceNameDropDown] = useState([]);
  useEffect(() => {
    if (!isEmpty(dropdownList)) {
      setSourceNameDropDown(
        dropdownList.map((option) => ({
          label: option,
        }))
      );
    } else {
      setSourceNameDropDown([]);
    }
  }, [dropdownList]);

  const subCategoryOptions = hasAdditionalRules
    ? OPTIONS_DATA_MAPPER.SOURCES_FORM_DEFERRAL_SUB_CATEGORIES
    : OPTIONS_DATA_MAPPER.SOURCES_FORM_OTHER_SUB_CATEGORIES;
  const subSubCategoryOptions =
    OPTIONS_DATA_MAPPER.SOURCES_FORM_DEFERRAL_SUB_SUB_CATEGORIES;

  return (
    <div>
      <Field
        isRequired
        name={fields.sourceCategory}
        label="Source Category"
        options={toOptionValuesFromMapper(
          OPTIONS_DATA_MAPPER.SOURCES_FORM_EMPLOYEE_CATEGORIES
        )}
        selectedValue={values[fields.sourceCategory]}
        onChange={onSourceCategoryChange}
        disabled={isEdit || isSave || values.sourceSubCategory === 11}
        component={FieldButtonGroup}
        size="smd"
      />
      {[2, 4].includes(values[fields.sourceCategory]) && (
        <div className="no-label-transform" key="sourceSubCategory">
          <Field
            noLabelTransform
            isRequired
            name={fields.sourceSubCategory}
            label="Sub-Category"
            options={
              values.sourceSubCategory === 11
                ? toOptionValuesFromMapper(subCategoryOptions).filter(
                    (x) => x.value === 11
                  )
                : toOptionValuesFromMapper(subCategoryOptions).filter(
                    (x) => x.value !== 11
                  )
            }
            selectedValue={values[fields.sourceSubCategory]}
            onChange={(value) => {
              deleteAdditionalAlloc();
              setFieldValue(fields.sourceSubCategory, value);
              setFieldValue(fields.sourceSubSubCategory, null); // Corrected reset logic
              setFieldValue(fields.sourceName, "");
            }}
            disabled={isEdit || isSave || values.sourceSubCategory === 11}
            component={FieldButtonGroup}
            size="lg"
          />
        </div>
      )}
      {[4].includes(values[fields.sourceSubCategory]) && (
        <Field
          key="sourceSubSubCategory"
          isRequired
          name={fields.sourceSubSubCategory}
          label="Catch Up"
          options={toOptionValuesFromMapper(subSubCategoryOptions)}
          selectedValue={values[fields.sourceSubSubCategory]}
          onChange={(value) => {
            setFieldValue(fields.sourceSubSubCategory, value);
            setFieldValue(fields.sourceName, "");
          }}
          disabled={isEdit || isSave || values.sourceSubCategory === 11}
          component={FieldButtonGroup}
          size="lg"
        />
      )}
      {[5].includes(values[fields.sourceSubCategory]) && (
        <Field
          key="sourceSubSubCategoryCatchUp"
          isRequired
          name={fields.sourceSubSubCategory}
          label="Catch Up"
          options={toOptionValuesFromMapper(subSubCategoryOptions)}
          selectedValue={values[fields.sourceSubSubCategory]}
          onChange={(value) => {
            setFieldValue(fields.sourceSubSubCategory, value);
            setFieldValue(fields.sourceName, "");
          }}
          disabled={isEdit || isSave || values.sourceSubCategory === 11}
          component={FieldButtonGroup}
          size="lg"
        />
      )}
      <Field
        isRequired
        name={fields.sourceName}
        label="Source Name"
        type="text"
        autoComplete="off"
        value={values[fields.sourceName]}
        disabled={isEdit || values.sourceSubCategory === 11}
        popupContent={
          <SourceDropdown
            data={sourceNameDropDown ? sourceNameDropDown : []}
            setData={setSourceNameDropDown}
            onSelect={(value, name) => {
              setFieldValue(fields.sourceName, name);
            }}
            setFieldValueOuter={setFieldValue}
            value={values[fields.sourceName]}
            payLoad={payload}
          />
        }
        component={FieldDropSide}
        noLabelTransform
      />
      {/* <Field
        isRequired
        name={fields.recordKeepingNumber}
        label="Source ID"
        type="text"
        autoComplete="off"
        value={values[fields.recordKeepingNumber]}
        onChange={handleChange}
        disabled={isEdit}
        component={FieldInput}
        noLabelTransform
        size="sm"
      /> */}
      <Field
        isRequired
        label="Effective start date"
        name={fields.effectiveStartDate}
        value={usDateFormat(values[fields.effectiveStartDate])}
        isDatePicker
        onClear={() => setFieldValue(fields.effectiveStartDate, null)}
        popupContent={
          <DatePicker
            onDayClick={(value) =>
              onDaySelected(fields.effectiveStartDate, value)
            }
            value={values[fields.effectiveStartDate]}
          />
        }
        disabled={isEdit && !isSave}
        component={FieldDropSide}
      />
      <Field
        label="Effective End date"
        name={fields.effectiveEndDate}
        value={usDateFormat(values[fields.effectiveEndDate])}
        isDatePicker
        onClear={() => setFieldValue(fields.effectiveEndDate, null)}
        popupContent={
          <DatePicker
            onDayClick={(value) =>
              onDaySelected(fields.effectiveEndDate, value)
            }
            value={usDateFormat(values[fields.effectiveEndDate])}
          />
        }
        disabled={isEdit && !isSave}
        component={FieldDropSide}
      />
      <Field
        isRequired
        name={fields.isNewContributionAllowed}
        label="New Contribution Allowed?"
        options={yesNoOptions}
        selectedValue={values[fields.isNewContributionAllowed]}
        onChange={(value) => {
          setFieldValue(fields.isNewContributionAllowed, value);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        size="sm"
      />
      <Field
        isRequired
        name={fields.isDisplayToParticipantWebsite}
        label="Display source to employee?"
        options={yesNoOptions}
        selectedValue={values[fields.isDisplayToParticipantWebsite]}
        onChange={(value) => {
          setFieldValue(fields.isDisplayToParticipantWebsite, value);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        size="sm"
      />
    </div>
  );
};

export default EmployeeForm;
